import Repository from '@/libs/axios'
import ListsRepository from '@/libs/customAxios/listsAxios'

const flagResource = '/admin/order/flag'
const flagSettingsResource = '/admin/flag'
const orderResource = '/admin/order?sort=-created_at'

const defaultPagination = 10
export default {
  createFlag(payload) {
    return Repository.post(`${flagResource}`, payload)
  },
  getOrders() {
    return Repository.get(`${orderResource}`)
  },
  getFlagList(filterQuery, pageNumber = 1, pagination = defaultPagination) {
    return ListsRepository.get(`${flagSettingsResource}?${filterQuery}&page=${pageNumber}&paginate=${pagination}`)
  },
  getFlagListNoPagination(filterQuery) {
    return ListsRepository.get(`${flagSettingsResource}?${filterQuery}&noPagination`)
  },
  fetchFlagDetails(id) {
    return Repository.get(`${flagSettingsResource}/${id}`)
  },
  updateFlagDetails(id, payload) {
    return Repository.put(`${flagSettingsResource}/${id}`, payload)
  },
  getFlagDropdownByStatus(status) {
    return ListsRepository.get(`/admin/flag-dropdown-list?status_key=${status}`)
  },
}
